import { createContext, useState, ReactNode, useContext, useCallback } from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'

export type ToasterHandler = (props: Omit<ToastProps, 'id'>) => void

const ToasterHandlerContext = createContext<ToasterHandler>(undefined as unknown as ToasterHandler)

interface ToastProps {
  id: string
  title?: string
  message: string
  variant?: string
}

interface Props {
  children: ReactNode
}

export function useToaster() {
  return useContext(ToasterHandlerContext)
}

export function ToasterProvider({ children }: Props) {
  const [toasts, setToasts] = useState<Array<ToastProps>>([])

  const showToaster = useCallback<ToasterHandler>(({ title = 'Samsechoes', message, variant = 'primary' }) => {
    setToasts(prevToasts => [{ id: uuidv4(), title, message, variant }, ...prevToasts])
  }, [])

  return (
    <ToasterHandlerContext.Provider value={showToaster}>
      <ToastContainer
        className="ToastContainer p-3"
        position="top-end"
        style={{ position: 'fixed', zIndex: 9999 }}
      >
        {toasts.map(({ id, title, message, variant }) => (
          <Toast
            key={id}
            onClose={() => setToasts(prevToasts => prevToasts.filter(t => t.id !== id))}
            bg={variant}
            autohide
          >
            <Toast.Header closeButton>
              <strong className="me-auto">{title}</strong>
            </Toast.Header>
            <Toast.Body>
              <div className="text-white">{message}</div>
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
      {children}
    </ToasterHandlerContext.Provider>
  )
}
